export default __webpack_public_path__ + "static/media/nocloseratio.5854d08b.jpg";